// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4a3a9222","453":"6a61b80e","732":"79bedcc3","977":"a9d9adee"}[chunkId] + ".chunk.js";
};